import React from 'react';
import PropTypes from 'prop-types';
import SnackBarWrapper from './SnackBarWrapper';
import { refSetter } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import _ from '../../../utils/lodash';

const locale = globals.getArea('error');

class ErrorHandler extends React.Component {
  state = {
    showError: false,
  };

  componentWillReceiveProps(nextProps) {
    if (_.isEqual(this.props.errorMessage, nextProps.errorMessage) && this.props.timeStamp !== nextProps.timeStamp) {
      this.snackbar.setAutoHideTimer();
    }
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.errorMessage !== nextProps.errorMessage ||
      this.props.timeStamp !== nextProps.timeStamp ||
      this.props.errorShown !== nextProps.errorShown
    );
  }

  setRef = refSetter.bind(this);
  handleCloseRequest = () => {
    this.props.dismissError();
  };
  render() {
    const { errorMessage, errorParameters, errorDuration, translatable, errorShown } = this.props;
    const messageToShow = translatable ? locale.getMsg(errorMessage, errorParameters) : errorMessage;
    return (
      <SnackBarWrapper
        ref={this.setRef('snackbar')}
        open={!errorShown}
        message={messageToShow}
        action={locale.getMsg('dismiss')}
        autoHideDuration={errorDuration}
        onActionTouchTap={this.handleCloseRequest}
        onRequestClose={this.handleCloseRequest}
      />
    );
  }
}

ErrorHandler.defaultProps = {
  errorMessage: null,
  errorDuration: null,
  timeStamp: '',
  errorParameters: [],
};

ErrorHandler.propTypes = {
  errorMessage: PropTypes.string,
  dismissError: PropTypes.func.isRequired,
  errorDuration: PropTypes.number,
  translatable: PropTypes.bool.isRequired,
  errorParameters: PropTypes.arrayOf(PropTypes.string),
  timeStamp: PropTypes.string,
  errorShown: PropTypes.bool.isRequired,
};

export default ErrorHandler;
